import { PartnerProductCard, PartnerProductCardProps } from './PartnerProductCard'

export default PartnerProductCard

export { type PartnerProductCardProps, PartnerProductCard }
